<template>
  <div>
    <!-- 校友资源详情 -->
    <div class="alumniDetailsDiv">
      <div class="welcome">
        亲爱的同学，好久不见！
        <br />
        请完善学籍卡信息，便于其他校友找到你
      </div>
      <div class="alumniDetails">
        <div class="alumniPhotoDiv">
          <img :src="this.alumnus.url" alt="" class="alumniPhoto" />
          <div class="sexDiv">
            <img src="../../assets/image/btn_nan_nor.png" alt="男" v-if="this.alumnus.sex == 1" class="sexImage" />
            <img src="../../assets/image/btn_nv_nor.png" alt="女" class="sexImage" v-else />
          </div>
          <div class="adress">{{ this.alumnus.city }}</div>
        </div>
        <div class="alumniData">
          <div class="alumniNameAndBtn">
            <div class="alumniName">{{ this.alumnus.name }}</div>
          </div>
          <div class="alumniCard">
            <div class="schoolAndGraduation">
              {{ this.alumnus.school }} &nbsp;&nbsp;
              {{ this.alumnus.xuejie }}
            </div>
            <el-form :model="postCard" :rules="rules" ref="postCard" class="demo-ruleForm">
              <div class="industrySelect">
                <el-form-item prop="hangye">
                  <el-select placeholder="请选择从事行业" v-model="postCard.hangye" @click.native="getPopupResources">
                    <el-option v-for="item in this.industry" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="company">
                <el-form-item prop="danwei">
                  <el-input v-model="postCard.danwei" placeholder="请输入工作单位"></el-input>
                </el-form-item>
              </div>
            </el-form>
            <div class="phone">微信/电话：{{ this.alumnus.phone }}</div>
          </div>
        </div>
      </div>
      <div class="alumniCardImgDiv">
        <img src="../../assets/image/btn_yuan_nor.png" class="alumniCardImg" alt="" />
      </div>
      <div class="provideResourcesDiv">
        提供资源：
        <!-- <div class="provideResources" v-if="this.alumnus.industry == ''">
          <div class="none">无</div>
        </div> -->
        <div class="provideResources clearfix">
          <div class="provideResourcesName" v-for="item in provideResource" :key="item">
            {{ item }}
          </div>
        </div>
        <br />
        <button class="addResources" @click="showResourcesPopup">
          + 添加资源
        </button>
      </div>
      <div class="resourcesExplainDiv">
        资源说明：

        <div class="resourcesExplain">
          <el-input type="text" placeholder="请输入内容" v-model="postCard.industryNotice" maxlength="50" show-word-limit>
          </el-input>
        </div>
      </div>
      <div class="needResourcesDiv">
        需求资源：
        <div class="provideResources clearfix">
          <div class="provideResourcesName" v-for="item in needResource" :key="item">
            {{ item }}
          </div>
        </div>
        <br />
        <button class="addResources" @click="showNeedResourcesPopup">
          + 添加资源
        </button>
      </div>
      <div class="resourcesExplainDiv">
        资源说明：

        <div class="resourcesExplain">
          <el-input type="text" placeholder="请输入内容" v-model="postCard.needNotice" maxlength="50" show-word-limit>
          </el-input>
        </div>
      </div>
      <!--  <div class="resourcesExplainDiv">
        资源说明：
        <div class="resourcesExplain" v-if="alumnus.need_notice == null">
          <div class="none">无</div>
        </div>
        <div class="resourcesExplain" v-else>
          {{ this.alumnus.need_notice }}
        </div>
      </div> -->
      <div class="hobbyDiv">
        兴趣爱好：
        <div class="hobby clearfix">
          <div class="hobbyName" v-for="item in hobby" :key="item" @click="clickHobby('hobby' + item, item)"
            :id="'hobby' + item">
            {{ item }}
          </div>
        </div>
        <div class="openDiv">
          <div class="open">
            公开名片：
            <van-switch v-model="checked" active-color="#00706E" inactive-color="#dcdee0" size="20px" />
          </div>
          <div class="openExplain">公开名片后，手机号码对其他校友可见</div>
        </div>
        <button class="updateCard" @click="updateCard">提 交</button>
      </div>
    </div>
    <!-- 提供资源弹窗 -->
    <van-popup round v-model="resourceShow" position="top" :style="{ height: '70%' }" class="resourcesPopup">
      <div class="popupData clearfix">
        <div class="popupDataResources">
          <div class="industry" v-for="item in industry" :key="item" @click="getIndustry('industry' + item, item)"
            :id="'industry' + item">
            {{ item }}
          </div>
        </div>
        <div class="industryNameDiv clearfix">
          <div class="industryName" v-for="index in industryName" :key="index" :id="'industryName' + index"
            @click="clickIndustryName('industryName' + index, index)">
            {{ index }}
          </div>
        </div>
      </div>
      <div class="btnDiv">
        <button class="addBtn" @click="resourceShow = false">添加</button>
        <div class="addNum">{{ this.provideResource.length }}/5</div>
      </div>
    </van-popup>
    <!-- 资源弹窗结束 -->

    <!-- 需求资源弹窗 -->
    <van-popup round v-model="resourceNeedShow" position="top" :style="{ height: '70%' }" class="resourcesPopup">
      <div class="popupData clearfix">
        <div class="popupDataResources">
          <div class="needIndustry" v-for="item in industry" :key="item"
            @click="getNeedIndustry('needIndustry' + item, item)" :id="'needIndustry' + item">
            {{ item }}
          </div>
        </div>
        <div class="industryNameDiv clearfix">
          <div class="needIndustryName" v-for="index in industryName" :key="index" :id="'needIndustryName' + index"
            @click="
              clickNeedIndustryName('needIndustryName' + index, index)
            ">
            {{ index }}
          </div>
        </div>
      </div>
      <div class="btnDiv">
        <button class="addBtn" @click="resourceNeedShow = false">添加</button>
        <div class="addNum">{{ this.needResource.length }}/5</div>
      </div>
    </van-popup>
    <!-- 资源弹窗结束 -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      alumnus: "",
      checked: true,
      industry: "",
      hobby: [],
      hobbyList: [],
      resourceShow: false,
      resourceNeedShow: false,
      industryName: [],
      industryNameList: [],
      is_provideResource: "",
      provideResource: [],
      needResource: [],
      postCard: {
        userId: window.localStorage.getItem("user_id"),
        isOpen: "",
        hobby: "",
        needNotice: "",
        need: "",
        industryNotice: "",
        industry: "",
        hangye: "",
        danwei: "",
      },
      rules: {
        hangye: [
          { required: true, message: "请选择从事行业", trigger: "blur" },
        ],
        danwei: [
          { required: true, message: "请输入工作单位", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getAlumnus();
    this.getHobby();
  },
  mounted() {
    document.getElementsByClassName("el-input__suffix")[0].remove();
    /* for (let i = 0; i < this.hobbyList.length; i++) {
      console.log("!!!");
      document.getElementById("hobby" + this.hobbyList[i].id).style.color =
        "#00706E";
      document.getElementById(id).style.borderColor = "#00706E";
    } */
  },
  methods: {
    async getAlumnus() {
      const result = await this.$http.get("/myBusinessCard/getBusinessCard", {
        params: { userId: window.localStorage.getItem("user_id") }
      });
      this.alumnus = result.data.detailInfo;
      if (this.alumnus.isOpen == 0) {
        this.checked = false;
      } else {
        this.checked = true;
      }
    },
    async getHobby() {
      const result = await this.$http.get("/myFriend/getHobby");
      this.hobby = result.data;
    },
    /* // 资源弹窗的1级请求
    async getPopupResources() {
      const result = await this.$http.get("/amresources/getIndustryLevelList");
      this.industry = result.data.IndustryLevelList;
    }, */
    // 提供资源
    showResourcesPopup() {
      this.getPopupResources();
      this.resourceShow = true;
    },
    // 需求资源
    showNeedResourcesPopup() {
      this.getPopupResources();
      this.resourceNeedShow = true;
    },
    // 资源弹窗的1级请求
    async getPopupResources() {
      const result = await this.$http.get("/amresources/getIndustryLevelList");
      this.industry = result.data.IndustryLevelList;
    },
    // 资源弹窗的2级请求
    async getIndustry(item, name) {
      const result = await this.$http.get("/amresources/getIndustryList", {
        params: { industryLevel: item.substr(8) },
      });
      this.industryName = result.data.IndustryList;
      const changeColor = document.getElementsByClassName("industry");
      for (let i = 0; i < changeColor.length; i++) {
        changeColor[i].style.color = "#333333";
      }
      document.getElementById(item).style.color = "#00706E";
    },
    // 提供资源
    clickIndustryName(index, name) {
      if (document.getElementById(index).style.color === "rgb(57, 135, 251)") {
        document.getElementById(index).style.color = "#333333";
        document.getElementById(index).style.borderColor = "#bfbfbf";
        for (let i = 0; i < this.industryName.length; i++) {
          if (this.provideResource[i] === name) {
            this.provideResource.splice(i, 1);
            i--;
            console.log(this.provideResource);
            //this.provideResource = this.industryNameList;
          }
        }
      } else {
        this.provideResource.push(name);
        //this.provideResource = this.industryNameList;
        if (this.provideResource.length > 5) {
          this.provideResource.splice(5);
          //this.provideResource = this.industryNameList;
        }
        console.log(this.provideResource);
        document.getElementById(index).style.color = "#00706E";
        document.getElementById(index).style.borderColor = "#00706E";
      }
    },

    // 需求资源弹窗的2级请求
    async getNeedIndustry(item, name) {
      const result = await this.$http.get("/amresources/getIndustryList", {
        params: { industryLevel: item.substr(12) },
      });
      this.industryName = result.data.IndustryList;
      const changeColor = document.getElementsByClassName("needIndustry");
      for (let i = 0; i < changeColor.length; i++) {
        changeColor[i].style.color = "#333333";
      }
      document.getElementById(item).style.color = "#00706E";
    },
    // 需求资源
    clickNeedIndustryName(index, name) {
      if (document.getElementById(index).style.color === "rgb(57, 135, 251)") {
        document.getElementById(index).style.color = "#333333";
        document.getElementById(index).style.borderColor = "#bfbfbf";
        for (let i = 0; i < this.industryName.length; i++) {
          if (this.needResource[i] === name) {
            this.needResource.splice(i, 1);
            i--;
            console.log(this.needResource);
            //this.needResource = this.industryNameList;
          }
        }
      } else {
        this.needResource.push(name);
        // this.needResource = this.industryNameList;
        if (this.needResource.length > 5) {
          this.needResource.splice(5);
          /// this.needResource = this.industryNameList;
        }
        console.log(this.needResource);
        document.getElementById(index).style.color = "#00706E";
        document.getElementById(index).style.borderColor = "#00706E";
      }
    },
    clickHobby(id, name) {
      console.log("传入" + id);
      console.log("传入" + name);
      if (document.getElementById(id).style.color === "rgb(57, 135, 251)") {
        document.getElementById(id).style.color = "#999999";
        document.getElementById(id).style.borderColor = "#999999";
        for (let i = 0; i < this.hobby.length; i++) {
          if (this.hobbyList[i] === name) {
            this.hobbyList.splice(i, 1);
            i--;
            console.log(this.hobbyList);
            //this.needResource = this.industryNameList;
          }
        }
      } else {
        this.hobbyList.push(name);
        console.log(this.hobbyList);
        // this.needResource = this.industryNameList;
        if (this.hobbyList.length > 5) {
          this.hobbyList.splice(5);
          /// this.needResource = this.industryNameList;
        }
        document.getElementById(id).style.color = "#00706E";
        document.getElementById(id).style.borderColor = "#00706E";
      }
    },
    updateCard() {
      this.$refs.postCard.validate(async (valid) => {
        // 请求api之前的一个前端验证
        if (!valid) {
          return;
        }
        if (this.checked === true) {
          this.postCard.isOpen = 1;
        } else {
          this.postCard.isOpen = 0;
        }
        this.postCard.hobby = this.hobbyList.toString();
        this.postCard.need = this.needResource.toString();
        this.postCard.industry = this.provideResource.toString();
        console.log(this.postCard);
        const result = await this.$http({
          url: "/myBusinessCard/editCard",
          method: "POST",
          //headers: { "content-type": "application/x-www-form-urlencoded" },
          data: this.postCard,
        });
        if (result.data.msg == '更新成功') {
          this.$toast("修改成功");
          window.history.back(-1);
        } else {
          this.$toast(result.data.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.alumniDetailsDiv {
  margin-top: 20px;
  position: relative;
  left: 5%;
  width: 90vw;
  background-color: white;
  border-radius: 15px;
  box-shadow: 2px 3px 8px 0px rgba(3, 29, 19, 0.29);
}

.welcome {
  text-align: center;
  padding-top: 20px;
  margin-bottom: 20px;
  font-size: 1.1rem;
  font-weight: bold;
  color: #333333;
}

.alumniDetails {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.alumniPhotoDiv {
  position: relative;
  width: 25%;
  padding: 10px 0px 0px 10px;
}

.alumniPhoto {
  width: 100%;
  height: 22.5vw;
  border-radius: 999px;
}

.sexDiv {
  width: 20px;
  position: absolute;
  left: 80%;
  top: 10px;
}

.sexImage {
  width: 100%;
}

.adress {
  padding-top: 5px;
  text-align: center;
  font-size: 1.2em;
  color: #00706E;
  font-weight: bold;
}

.alumniData {
  padding-left: 15px;
  width: 66%;
}

.alumniNameAndBtn {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}

.alumniName {
  font-size: 1.3em;
  font-weight: bold;
}

.updateCard {
  font-size: 1.2em;
  border: 0;
  border-radius: 20px;
  color: #00706E;
  font-weight: bold;
  margin-right: 10px;
}

.schoolAndGraduation {
  font-size: 1.1em;
  color: #666666;
  padding-top: 5px;
}

/* .industry {
  font-size: 1.1em;
  color: #666666;
  padding-top: 5px;
  text-decoration: underline;
} */
.el-select {
  width: 100%;
}

/deep/.el-form-item__content {
  line-height: 0;
}

.industrySelect,
.company {
  /deep/.el-input__inner {
    border-top-width: 0;
    border-left-width: 0;
    border-right-width: 0;
    padding: 0;
    color: #666666;
  }
}

.company {
  color: #666666;
}

.phone {
  font-size: 1.1em;
  color: #666666;
  margin-top: 15px;
  padding-bottom: 20px;
}

.alumniCardImgDiv {
  position: absolute;
  top: 10%;
  right: 0%;
  width: 30%;
}

.alumniCardImg {
  width: 100%;
  height: 100%;
}

.provideResourcesDiv {
  font-size: 1.3em;
  font-weight: bold;
  padding: 0 10px;
}

.addResources {
  margin-top: 10px;
  font-size: 1.1rem;
  padding: 3px 8px;
  background: #ffffff;
  border: 2px solid #999999;
  border-radius: 15px;
  font-weight: bold;
  color: #999999;
}

/* .provideResources {
  display: flex;
} */
.provideResourcesName {
  float: left;
  font-size: 0.9em;
  border-width: 1.5px 1.5px 1.5px 1.5px;
  border-style: solid;
  border-color: #00706E;
  border-radius: 15px;
  padding: 3px 8px 3px 8px;
  color: #00706E;
  margin-right: 10px;
  margin-top: 15px;
}

.resourcesExplainDiv {
  margin-top: 20px;
  font-size: 1.3em;
  font-weight: bold;
  padding: 0 10px;
}

.resourcesExplain {
  padding-top: 10px;
  padding-right: 10px;
  font-size: 1rem;
  color: #333333;
  font-weight: normal;
  line-height: 1.5rem;
}

.needResourcesDiv {
  margin-top: 20px;
  font-size: 1.3em;
  font-weight: bold;
  padding: 0 10px;
}

.needResources {
  display: flex;
}

.needResourcesName {
  font-size: 0.9em;
  border-width: 1.5px 1.5px 1.5px 1.5px;
  border-style: solid;
  border-color: #00706E;
  border-radius: 15px;
  padding: 3px 8px 3px 8px;
  color: #00706E;
  margin-right: 10px;
  margin-top: 15px;
}

.hobbyDiv {
  margin: 20px 0;
  font-size: 1.3em;
  font-weight: bold;
  padding: 0 10px;
  position: relative;
  min-height: 30vh;
  background-image: url(../../assets/image/btn_xiaoyuan_nor.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.hobby {
  margin-top: 15px;
}

.hobbyName {
  float: left;
  font-size: 0.9em;
  border-width: 1.5px 1.5px 1.5px 1.5px;
  border-style: solid;
  border-color: #999999;
  border-radius: 15px;
  padding: 3px 8px 3px 8px;
  color: #999999;
  margin-right: 10px;
}

.hobbyImg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0%;
  top: 0%;
}

.none {
  font-size: 1rem;
  font-weight: normal;
  padding-top: 10px;
}

.van-switch {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.openDiv {
  position: relative;
}

.open {
  position: relative;
  margin-top: 20px;
}

.openExplain {
  margin-top: 20px;
  font-size: 1rem;
  font-weight: bold;
  color: #00706E;
  text-align: center;
  line-height: 1.5rem;
}

.resourcesDiv {
  float: left;
  position: absolute;
  left: 0%;
  padding-top: 5px;
}

.resources {
  background-color: #f5f5f5;
  font-size: 1.2em;
  color: #333333;
  font-weight: 600;
  padding: 0px;
  line-height: normal;
}

.schoolFriends {
  float: left;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.schoolFriendsBtn {
  border: none;
  background-image: linear-gradient(to left, #00706E, #00706E);
  color: white;
  border-radius: 20px;
  font-size: 1em;
  padding: 8px 15px 8px 15px;
}

.search {
  float: right;
}

.searchPopupDiv {
  background-color: #f5f5f5;
  font-size: 1.2em;
  color: #333333;
  font-weight: 600;
  padding: 0px;
  line-height: normal;
}

.searchImg {
  width: 6.5vw;
  max-width: 50px;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.resourcesPopupSeach {
  position: relative;
  background-color: #f5f5f5;
  height: 8vw;
}

.provincePopupSeach {
  position: relative;
  background-color: #f5f5f5;
  height: 8vw;
}

.popupResources {
  float: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5%;
  font-size: 1.2em;
  font-weight: bold;
  color: #00706E;
}

.popupData {
  height: 80%;
}

.popupDataResources {
  width: 35%;
  height: 100%;
  overflow-y: scroll;
  float: left;
}

.popupDataResources::-webkit-scrollbar {
  display: none;
}

.industry {
  border-width: 0 1px 0 0;
  border-style: solid;
  border-color: #bfbfbf;
  padding: 15px 0px 15px 0px;
  text-align: center;
  color: #333333;
  font-weight: bold;
}

.needIndustry {
  border-width: 0 1px 0 0;
  border-style: solid;
  border-color: #bfbfbf;
  padding: 15px 0px 15px 0px;
  text-align: center;
  color: #333333;
  font-weight: bold;
}

.province {
  border-width: 0 1px 0 0;
  border-style: solid;
  border-color: #bfbfbf;
  padding: 15px 0px 15px 0px;
  text-align: center;
  color: #333333;
  font-weight: bold;
}

.industryNameDiv {
  position: relative;
  float: right;
  width: 65%;
  height: 100%;
  overflow-y: scroll;
}

.industryNameDiv::-webkit-scrollbar {
  display: none;
}

.industryName {
  position: relative;
  border: 1px solid #bfbfbf;
  width: 35%;
  float: left;
  text-align: center;
  padding: 2%;
  margin-top: 15px;
  left: 8%;
  margin-right: 4%;
  border-radius: 3px;
  color: #333333;
  font-size: 0.9em;
}

.needIndustryName {
  position: relative;
  border: 1px solid #bfbfbf;
  width: 35%;
  float: left;
  text-align: center;
  padding: 2%;
  margin-top: 15px;
  left: 8%;
  margin-right: 4%;
  border-radius: 3px;
  color: #333333;
  font-size: 0.9em;
}

.btnDiv {
  position: relative;
  width: 100%;
  height: 20%;
  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: #bfbfbf;

  .addBtn {
    width: 60%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 10px 0;
    border-radius: 20px;
    border: 0;
    color: white;
    background-image: linear-gradient(to left, #00706E, #00706E);
  }

  .addNum {
    position: absolute;
    left: 88%;
    top: 50%;
    transform: translateY(-50%);
  }
}

.updateCard {
  width: 80%;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
  margin: 20px 0;
  padding: 10px 0;
  border-radius: 20px;
  border: 0;
  font-size: 1.2rem;
  color: white;
  background-image: linear-gradient(to left, #00706E, #00706E);
}
</style>



// WEBPACK FOOTER //
// src/components/mine/MyCardUpdate.vue